module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "quill-editor"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fef91656!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-quill-editor/editor.vue
// module id = 203
// module chunks = 2